import React, { useState, useEffect } from "react";
import axios from "axios";
import { useTranslation } from "react-i18next";

function AddressLogs() {
  const { t } = useTranslation();
  const shop =
    new URLSearchParams(window.location.search).get("shop") ||
    "victorgroups.myshopify.com";
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    setLoading(true);
    axios
      .get(
        `${
          process.env.NODE_ENV === "production"
            ? "https://fr-xfinder.vercel.app"
            : "http://localhost:3000"
        }/validations?shop=${shop}`
      )
      .then((response) => {
        setLogs(response.data.data.validations || []);
        setLoading(false);
      })
      .catch((err) => {
        console.error("❌ Fetch logs error:", err.message);
        setError(t("addressLogs.fetchError"));
        setLoading(false);
      });
  }, [shop, t]);

  return (
    <div className="min-h-screen bg-gray-100 p-4 sm:p-6">
      <div className="max-w-full sm:max-w-7xl mx-auto">
        <h1 className="text-2xl sm:text-3xl font-bold text-gray-800 mb-4 sm:mb-6">
          {t("addressLogs.title")}
        </h1>
        {error && (
          <div className="bg-red-100 border-l-4 border-red-500 text-red-700 p-3 sm:p-4 mb-4 sm:mb-6 rounded-md text-sm sm:text-base">
            {error}
          </div>
        )}
        {loading ? (
          <div className="text-gray-600 text-center text-sm sm:text-base">
            {t("addressLogs.loading")}
          </div>
        ) : (
          <div className="bg-white p-4 sm:p-6 rounded-lg shadow-md overflow-x-auto">
            <table className="w-full table-auto">
              <thead>
                <tr className="bg-gray-100">
                  <th className="px-2 py-1.5 sm:px-4 sm:py-2 text-left text-gray-700 text-sm sm:text-base">
                    {t("addressLogs.address")}
                  </th>
                  <th className="px-2 py-1.5 sm:px-4 sm:py-2 text-left text-gray-700 text-sm sm:text-base">
                    {t("addressLogs.city")}
                  </th>
                  <th className="px-2 py-1.5 sm:px-4 sm:py-2 text-left text-gray-700 text-sm sm:text-base">
                    {t("addressLogs.country")}
                  </th>
                  <th className="px-2 py-1.5 sm:px-4 sm:py-2 text-left text-gray-700 text-sm sm:text-base">
                    {t("addressLogs.status")}
                  </th>
                  <th className="px-2 py-1.5 sm:px-4 sm:py-2 text-left text-gray-700 text-sm sm:text-base">
                    {t("addressLogs.timestamp")}
                  </th>
                </tr>
              </thead>
              <tbody>
                {logs.map((log, index) => (
                  <tr key={index} className="border-b">
                    <td className="py-1.5 px-2 sm:py-2 sm:px-4 text-gray-600 text-sm sm:text-base">
                      {log.address.address1}
                    </td>
                    <td className="py-1.5 px-2 sm:py-2 sm:px-4 text-gray-600 text-sm sm:text-base">
                      {log.address.city}
                    </td>
                    <td className="py-1.5 px-2 sm:py-2 sm:px-4 text-gray-600 text-sm sm:text-base">
                      {log.address.country_code}
                    </td>
                    <td className="py-1.5 px-2 sm:py-2 sm:px-4 text-sm sm:text-base">
                      {log.result.status === "pobox" && (
                        <span className="text-red-700">
                          {t("addressLogs.pobox")}
                        </span>
                      )}
                      {log.result.status === "freight" && (
                        <span className="text-red-700">
                          {t("addressLogs.freight")}
                        </span>
                      )}
                      {log.result.status === "mailbox" && (
                        <span className="text-red-700">
                          {t("addressLogs.mailbox")}
                        </span>
                      )}
                      {log.result.status === "rural" && (
                        <span className="text-yellow-700">
                          {t("addressLogs.rural")}
                        </span>
                      )}
                      {log.result.status === "mismatch" && (
                        <span className="text-yellow-700">
                          {t("addressLogs.mismatch")}
                        </span>
                      )}
                      {log.result.status === "invalid" && (
                        <span className="text-red-700">
                          {t("addressLogs.invalid")}
                        </span>
                      )}
                      {log.result.status === "valid" && (
                        <span className="text-green-700">
                          {t("addressLogs.valid")}
                        </span>
                      )}
                    </td>
                    <td className="py-1.5 px-2 sm:py-2 sm:px-4 text-gray-600 text-sm sm:text-base">
                      {new Date(log.timestamp).toLocaleString()}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}

export default AddressLogs;
